import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import { Tooltip } from 'wix-style-react'
import { ChromePicker } from 'react-color'
import { BLUE } from 'components/styles'
import { toFirebaseKey } from 'utils/utils'
import Text from 'components/common/Text'

const OptionsEditorContainer = styled.div`
  margin-left: 2em;
  margin-right: 2em;
`
const OptionBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 1em;
`
const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-top: 0.5em;
`
const OptionContainer = styled.div`
  text-align: center;
  margin-right: 1em;
`
const ColorBox = styled.div`
  min-width: 3em;
  max-width: 6em;
  min-height: 1em;
  border-radius: 2px;
  border: solid 1px ${BLUE};
  text-align: center;
  cursor: pointer;
  background-color: ${props => props.color ? props.color : '#FFF'};
`

const DescContainer = styled.div`
  width: 6em;
  line-height: 0.5;
  margin-right: 1em;
`
const ClearContainer = styled.div`
  text-align: center;
  cursor: pointer;
`

class OptionsView extends Component {

  onChangeColor (title) {
    return color => {
      // console.log('color changed', title, color)
      this.props.updateProductColor(title, color.hex)
    }
  }

  renderColorPicker (currentColor, title) {
    return (
      <div id={'colorPicker'}>
        <ChromePicker
          color={currentColor}
          onChangeComplete={this.onChangeColor(title)}
        />
      </div>
    )
  }

  renderOptionContent (currentColor, title) {
    if (currentColor) {
      return (
        <ColorBox color={currentColor} />
      )
    } else {
      return (
        <ColorBox>
          <Text size='medium'>{title}</Text>
        </ColorBox>
      )
    }
  }

  onClear = (title) => {
    return () => {
      // console.log('onClear', title)
      this.props.updateProductColor(title, null)
    }
  }

  renderClear (currentColor, title) {
    if (currentColor) {
      return (
        <ClearContainer onClick={this.onClear(title)}>
          <Text size='medium' color={BLUE}>Clear</Text>
        </ClearContainer>
      )
    }
  }

  renderOptionValue = (value, index) => {
    // console.log('renderOption', option)
    const { productInfo } = this.props
    const currentColor = _.get(productInfo, ['colorOptions', toFirebaseKey(value)])
    return (
      <OptionContainer key={index}>
        <Tooltip
          content={this.renderColorPicker(currentColor, value)}
          hideTrigger='click'
          onClickOutside={null}
          onShow={null}
          placement='bottom'
          shouldCloseOnClickOutside
          showTrigger='click'
        >
          {this.renderOptionContent(currentColor, value)}
        </Tooltip>
        {this.renderClear(currentColor, value)}
      </OptionContainer>
    )
  }

  renderOptionBlock = (option, key) => {
    // console.log('renderVariant', variant)
    return (
      <OptionBlock key={key}>
        <Text>{option.name}</Text>
        <OptionsContainer>
          <DescContainer>
            <Text size='medium'>Click to replace text with a color</Text>
          </DescContainer>
          {_.map(option.values, this.renderOptionValue)}
        </OptionsContainer>
      </OptionBlock>
    )
  }

  render () {
    const { productInfo } = this.props
    const options = _.get(productInfo, ['details', 'options'], [])
    // console.log('variants', variants)
    return (
      <OptionsEditorContainer>
        {_.map(options, this.renderOptionBlock)}
      </OptionsEditorContainer>
    )
  }
}

OptionsView.propTypes = {
  productInfo: PropTypes.object,
  updateProductColor: PropTypes.func
}

export default OptionsView



// WEBPACK FOOTER //
// ./src/components/editor/popovers/shopifyVariantsPopover/OptionsView.js